import React, { useState } from "react";
import { Landmark, Home, TrendingUp, Umbrella, CreditCard, Wallet } from "lucide-react";

const INDUSTRIES = [
  { id: "banking", icon: Landmark, name: "Banking", areas: ["Customer service", "Employee copilots", "Sensitive-data controls", "AI agents", "Operational workflows"] },
  { id: "mortgages", icon: Home, name: "Mortgages", areas: ["Broker conversations", "Customer vulnerability", "Advice / support boundaries", "Call QA", "Customer communications"] },
  { id: "wealth", icon: TrendingUp, name: "Wealth & Investment", areas: ["Customer communications", "Potential advice risks", "AI assistants", "Employee copilots", "Review and evidence"] },
  { id: "insurance", icon: Umbrella, name: "Insurance", areas: ["Customer support", "Claims interactions", "Vulnerability", "Call QA", "AI-generated communications"] },
  { id: "credit", icon: CreditCard, name: "Consumer Credit", areas: ["Affordability-related conversations", "Financial difficulty", "Customer support", "Vulnerability", "QA"] },
  { id: "payments", icon: Wallet, name: "Payments & Fintech", areas: ["Customer-facing AI", "Fraud-support workflows", "Agentic AI", "Employee AI", "Operational oversight"] },
];

export default function IndustrySelector() {
  const [active, setActive] = useState(INDUSTRIES[0].id);
  const cur = INDUSTRIES.find((i) => i.id === active);
  const Icon = cur.icon;

  return (
    <div data-testid="fs-industry-selector">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2.5">
        {INDUSTRIES.map((ind) => {
          const IIcon = ind.icon;
          const on = ind.id === active;
          return (
            <button key={ind.id} onClick={() => setActive(ind.id)} data-testid={`fs-industry-${ind.id}`}
              className={`flex flex-col items-center gap-2 rounded-xl border px-3 py-4 text-center transition-colors ${on ? "border-primary/40 bg-primary/[0.07]" : "border-white/10 bg-navy-900/60 hover:border-white/20"}`}>
              <span className={`inline-flex h-10 w-10 items-center justify-center rounded-lg ${on ? "bg-primary/15 text-primary" : "bg-white/[0.04] text-muted-foreground"}`}><IIcon className="h-5 w-5" /></span>
              <span className={`text-xs font-medium leading-tight ${on ? "text-foreground" : "text-muted-foreground"}`}>{ind.name}</span>
            </button>
          );
        })}
      </div>

      <div className="mt-4 rounded-lg border border-white/10 bg-navy-900/60 p-6 sm:p-8">
        <div className="flex items-center gap-3">
          <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-primary/12 text-primary"><Icon className="h-5 w-5" /></span>
          <h3 className="text-xl font-bold text-foreground">{cur.name}</h3>
        </div>
        <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-2.5">
          {cur.areas.map((a) => (
            <div key={a} className="flex items-center gap-2.5 rounded-lg border border-white/10 bg-navy-800/50 px-3.5 py-2.5 text-sm text-foreground/90">
              <span className="h-1.5 w-1.5 rounded-full bg-primary" /> {a}
            </div>
          ))}
        </div>
        <p className="mt-5 text-xs text-muted-foreground/70">Not every use case carries identical regulatory requirements. Controls are configured to your firm's policy and obligations.</p>
      </div>
    </div>
  );
}
